import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Footer from './Footer';
import config from "./common/Config";
import { toast } from 'sonner';
import { setTableWidths, getTableWidths, setTableColumnVisibility, getTableColumnVisibility } from "../data/postAPi";
import generateMultipleSummaryPDF from "./trip/generateMultipleSummaryPDF_dds";
import ManageColumns from "./tableComponents/manageColumns/ManageColumns";
import FallbackManageColumns from "./tableComponents/manageColumns/FallbackManageColumns";
import StandaloneManageColumnsModal from "./tableComponents/manageColumns/StandaloneManageColumnsModal";
import {
	Box,
	Container,
	Breadcrumbs,
	Typography,
	Paper,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	IconButton,
	Stack,
	TablePagination,
	TableCell,
	TableRow,
	TableHead,
	TableBody,
	TableContainer,
	Table,
	CircularProgress,
	TextField,
	Checkbox,
	Autocomplete,
} from "@mui/material";
import { Iconify } from './Minimal/src/components/iconify/iconify';
import "./common/commonStyles.css";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../utils/companySettingsCache";
import { fetchGetPicker } from "../utils/pickingApi";
import { encryptPayload, normalizeEncryptedApiResponse } from "../utils/customerCrypto";

const formatCellValue = (value) => {
	if (value === null || value === undefined) return '';
	if (Array.isArray(value)) {
		return value.reduce((sum, item) => sum + (Number(item?.amount) || 0), 0);
	}
	if (typeof value === 'object') {
		return value.amount ?? '';
	}
	return value;
};

const NewMarkDelivery = () => {
	const { manifestId } = useParams();
	const [options, setOptions] = useState([]);
	const [driver, setSelectedDriver] = useState('');
	const [manifestOrder, setmanifestOrder] = useState('');
	const [orderOptions, setorderOptions] = useState([]);
	const [isManifest, setIsManifest] = useState(false);
	const [selectedDriverName, setSelectedDriverName] = useState('');
	const [manifestNo, setManifestNo] = useState('');
	const [manifestDate, setManifestDate] = useState('');
	const [companySettings, setCompanySettings] = useState(null);
	const [howManyInvoiceCanPrint, setHowManyInvoiceCanPrint] = useState(1);
	const [pickerOptions, setPickerOptions] = useState([]);
	const [selectedPicker, setSelectedPicker] = useState('');
	const [selectedPickerName, setSelectedPickerName] = useState('');
	const [showPickerModal, setShowPickerModal] = useState(false);

	const [isAllSelected, setIsAllSelected] = useState(false);
	const [selectedRows, setSelectedRows] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [allTableData, setAllTableData] = useState([]); // Store all data for pagination
	const [printProcessed, setPrintProcessed] = useState(false);
	const [pickingCreated, setPickingCreated] = useState(false);
	const [picklistUrl, setPicklistUrl] = useState('');
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(50);
	const [totalRecords, setTotalRecords] = useState(0);
	const [loading, setLoading] = useState(false);

	const accessToken = localStorage.getItem("accessToken");
	const token = localStorage.getItem("token");
	const navigate = useNavigate();
	const userId = localStorage.getItem("userId");
	const tableName = "newmarkdownTable";
	const isTsc = config.PREFIX === 'tsc';

	// Middle columns (between Sr. No and Action) vary by tenant.
	// TSC: replace Distance / Inv Date / Amt Dues with TSC-specific cash/cheque fields.
	const middleColumns = isTsc
		? [
			{ header: "Inv Number", key: "invoice_num", width: 100, type: "link", align: "left" },
			{ header: "Customer Name(A/C No)", key: "customer", width: 280, align: "left" },
			{ header: "Post Code", key: "postal_code", width: 100, align: "left" },
			{ header: "Inv Amt", key: "invoice_amt", width: 110, align: "center" },
			{ header: "Cod Cash", key: "tsc_cod_cash", width: 120, align: "center" },
			{ header: "Cod Cheque", key: "tsc_cod_cheque", width: 130, align: "center" },
			{ header: "Old Inv Cash", key: "old_inv_cash", width: 120, align: "center" },
			{ header: "Old Inv Cheque", key: "old_inv_cheque", width: 130, align: "center" },
		]
		: [
			{ header: "Distance", key: "mile", width: 120, align: "center" },
			{ header: "Inv Date", key: "date", width: 90, align: "left" },
			{ header: "Inv Number", key: "invoice_num", width: 100, type: "link", align: "left" },
			{ header: "Customer Name(A/C No)", key: "customer", width: 280, align: "left" },
			{ header: "Post Code", key: "postal_code", width: 120, align: "left" },
			{ header: "Inv Amt", key: "invoice_amt", width: 120, align: "center" },
			{ header: "Amt Dues", key: "previous_dues", width: 120, align: "center" },
		];

	const defaultWidths = [80, 80, ...middleColumns.map((c) => c.width), 100];
	const [colWidths, setColWidths] = useState(defaultWidths);

	const tableColumns = [
		{ header: "Checkbox", visible: true },
		{ header: "Sr. No", visible: true },
		...middleColumns.map((c) => ({ header: c.header, visible: true })),
		{ header: "Action", visible: true }
	];

	const [columnVisibility, setColumnVisibility] = useState(() => {
		const defaultVisibility = {};
		tableColumns.forEach((_, index) => {
			defaultVisibility[index] = true;
		});
		return defaultVisibility;
	});

	const [showFallbackModal, setShowFallbackModal] = useState(false);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		setRowsPerPage(newRowsPerPage);
		setPage(0);
	};

	const handleColumnVisibilityChange = async (newVisibility) => {
		setColumnVisibility(newVisibility);

		try {
			await setTableColumnVisibility(userId, tableName, newVisibility);
		} catch (error) {
		}
	};

	function debounce(func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

	const debouncedSetTableWidths = useRef(
		debounce((userId, tableName, widths) => {
			setTableWidths(userId, tableName, widths);
		}, 500)
	).current;

	const startResizing = (index, e) => {
		e.preventDefault();
		const startX = e.clientX;
		const startWidth = colWidths[index];

		const onMouseMove = (moveEvent) => {
			const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
			setColWidths((widths) => {
				const updated = [...widths];
				updated[index] = newWidth;
				debouncedSetTableWidths(userId, tableName, updated);
				return updated;
			});
		};

		const onMouseUp = () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};

		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
	};

	const checkPopupBlocker = () => {
		let testWindow;
		try {
			testWindow = window.open('', '_blank', 'width=1,height=1,top=0,left=0');

			if (!testWindow) {
				showPopupBlockedMessage();
				return false;
			}

			setTimeout(() => {
				try {
					if (testWindow.closed || !testWindow.location || testWindow.location.href === 'about:blank') {
						if (!testWindow.closed) {
							testWindow.close();
						}
					} else {
						testWindow.close();
					}
				} catch (e) {
					if (!testWindow.closed) {
						testWindow.close();
					}
				}
			}, 100);

			if (testWindow.outerHeight === 0 || testWindow.outerWidth === 0) {
				showPopupBlockedMessage();
				return false;
			}

			if (testWindow.screenX === 0 && testWindow.screenY === 0) {
				showPopupBlockedMessage();
				return false;
			}

			return true;
		} catch (e) {
			showPopupBlockedMessage();
			return false;
		}
	};

	const showPopupBlockedMessage = () => {
		toast.warning('Popups are blocked for this site. To enable printing, look for a popup blocker icon in your address bar and allow popups from this site, or go to browser Settings > Privacy > Pop-ups and redirects and add this site to the allowed list.');
	};

	const clearPrintUrlParam = () => {
		const url = new URL(window.location);
		url.searchParams.delete('print');
		window.history.replaceState({}, document.title, url.pathname + url.search);
	};

	useEffect(() => {
		async function fetchWidths() {
			try {
				const res = await getTableWidths(userId, tableName);
				if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
					const apiWidths = res.data.widths;
					let adjustedWidths = [...defaultWidths];

					if (apiWidths.length === 9 && defaultWidths.length === 10) {
						adjustedWidths = [defaultWidths[0], ...apiWidths];
					} else if (apiWidths.length === defaultWidths.length) {
						adjustedWidths = [...apiWidths];
					}
					const customerIdx = isTsc ? 3 : 5;
					const invIdx = isTsc ? 2 : 4;
					const dateIdx = isTsc ? null : 3;
					if (adjustedWidths[customerIdx] < defaultWidths[customerIdx]) {
						if (dateIdx != null) adjustedWidths[dateIdx] = defaultWidths[dateIdx];
						adjustedWidths[invIdx] = defaultWidths[invIdx];
						adjustedWidths[customerIdx] = defaultWidths[customerIdx];
					}

					setColWidths(adjustedWidths);
				} else {
					setColWidths(defaultWidths);
				}
			} catch (e) {
				setColWidths(defaultWidths);
			}
		}
		fetchWidths();
	}, [userId, tableName]);

	useEffect(() => {
		async function fetchColumnVisibility() {
			try {
				const visibilityResponse = await getTableColumnVisibility(userId, tableName);
				if (visibilityResponse?.data?.column_visibility) {
					setColumnVisibility(visibilityResponse.data.column_visibility);
				} else {
					const defaultVisibility = {};
					tableColumns.forEach((_, index) => {
						defaultVisibility[index] = true;
					});
					setColumnVisibility(defaultVisibility);
				}
			} catch (error) {
				const defaultVisibility = {};
				tableColumns.forEach((_, index) => {
					defaultVisibility[index] = true;
				});
				setColumnVisibility(defaultVisibility);
			}
		}
		fetchColumnVisibility();
	}, [userId, tableName]);


	useEffect(() => {
		async function fetchDriverOptions() {
			try {
				const response = await axios.post(
					`${config.API_URL}/getDriver`,
					{},
					{
						headers: {
							authorization: `Bearer ${accessToken}`,
						},
					}
				);

				if (!response.data || !response.data.data.driver || !Array.isArray(response.data.data.driver)) {
					throw new Error('Invalid response format or empty driver array');
				}

				const formattedOptions = response.data.data.driver.map(item => ({
					key: `${item.first_name} ${item.last_name}`,
					value: item.id,
				}));

				setOptions(formattedOptions);
			} catch (error) {
			}
		}

		fetchDriverOptions();
	}, [accessToken]);

	useEffect(() => {
		async function fetchPickerOptions() {
			try {
				const payload = await fetchGetPicker(token);

				if (!payload || !payload.picker || !Array.isArray(payload.picker)) {
					throw new Error('Invalid response format or empty picker array');
				}

				const formattedOptions = payload.picker.map(item => ({
					key: `${item.first_name} ${item.last_name}`.trim(),
					value: item.id,
				}));

				setPickerOptions(formattedOptions);
			} catch (error) {
			}
		}

		fetchPickerOptions();
	}, [accessToken]);

	useEffect(() => {
		async function fetchOrderOptions() {
			try {
				const response = await axios.get(`${config.API_URL}/manifest_orderlist`, {
					headers: {
						authorization: `Bearer ${token}`,
					},
				});
				if (!response.data || !response.data.data.orders || !Array.isArray(response.data.data.orders)) {
					throw new Error('Invalid response format or empty order array');
				}
				const manifest_orderOptions = response.data.data.orders.map(item => {
					const customerName = String(
						item.customer ||
						item.customer_name ||
						item.company ||
						item.biller ||
						""
					).trim();
					const accountNo = String(
						item.accound_no ||
						item.account_no ||
						item.customer_account_no ||
						""
					).trim();
					const customerLabel = customerName
						? (accountNo ? `${customerName}(${accountNo})` : customerName)
						: "";
					const referenceNo = String(item.reference_no || "").trim();
					return {
						key: referenceNo,
						value: item.id,
						customer: customerLabel,
						label: customerLabel
							? `${referenceNo} - ${customerLabel}`
							: referenceNo,
					};
				});

				setorderOptions(manifest_orderOptions);
			} catch (error) {
			}
		}
		fetchOrderOptions();
	}, [accessToken]);

	useEffect(() => {
		async function loadSettingsForDelivery() {
			try {
				const data = await getCompanySettings();
				setCompanySettings(data);
				if (data?.howmanyInvoiceCanPrint) {
					setHowManyInvoiceCanPrint(Number(data.howmanyInvoiceCanPrint));
				}
			} catch (error) {
			}
		}
		if (accessToken) {
			loadSettingsForDelivery();
		}
	}, [accessToken]);

	const checkPickingStatus = useCallback(async () => {
		if (!manifestId || !accessToken) return;

		try {
			const formData = new FormData();
			formData.append('manifest_id', manifestId);
			const orderIds = allTableData
				.map((row) => row?.id)
				.filter((id) => id !== undefined && id !== null && id !== '')
				.join(',');
			if (orderIds) {
				formData.append('order_id', orderIds);
			}

			const response = await fetch(`${config.API_URL}/manifest_list/check_picking_status`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to check picking status');
			}

			const result = await response.json();

			if (result.status === true && result.picking_exists === true) {
				let url = result.picklist_url;
				if (url) {
					if (url.includes('/api/admin')) {
						url = url.replace('/api/admin', '');
					} else if (url.includes('/api/')) {
						url = url.replace('/api', '');
					}
				} else {
					url = `${config.BASE_URL}/sales/view_picking_list/${result.picklist_number}`;
				}
				setPicklistUrl(url);
				setPickingCreated(true);
			} else {
				setPickingCreated(false);
				setPicklistUrl('');
			}
		} catch (error) {
		}
	}, [manifestId, accessToken, allTableData]);

	const fetchData = async () => {
		const formData = new FormData();
		formData.append('id_new', manifestId);
		formData.append('draw', 1);
		formData.append('start', 0);
		formData.append('length', 50);

		const apiUrl = `${config.API_URL}/manifest_list/get_mark_delivery`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});
			if (!response.ok) {
				throw new Error('Failed to fetch new sales data');
			}

			const data = await response.json();
			setIsManifest(data.is_manifest === 'Y');
			setSelectedDriver(data.driver_id);
			if (data && typeof data === 'object') {
				if (manifestId) setManifestNo(manifestId);
				if (data.manifest_date) setManifestDate(data.manifest_date);
			}

			if (data.driver_id) {
				const selectedDriverOption = options.find(option => option.value === data.driver_id);
				if (selectedDriverOption) {
					setSelectedDriverName(selectedDriverOption.key);
				}
			}
		} catch (error) {
		}
	};

	const fetchTableData = useCallback(async () => {
		if (!manifestId || !accessToken) return;

		setLoading(true);
		try {
			const formData = new FormData();
			formData.append('id_new', manifestId);
			formData.append('draw', 1);
			formData.append('start', 0);
			formData.append('length', 10000); // Get all data for client-side pagination

			const response = await fetch(`${config.API_URL}/manifest_list/get_mark_delivery`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch table data');
			}

			const json = await response.json();

			if (json && json.data) {
				setAllTableData(json.data);
				setTotalRecords(json.data.length);
				setIsManifest(json.is_manifest === 'Y');
				setSelectedDriver(json.driver_id);

				if (json.driver_id) {
					const selectedDriverOption = options.find(option => option.value === json.driver_id);
					if (selectedDriverOption) {
						setSelectedDriverName(selectedDriverOption.key);
					}
				}
			} else {
				setAllTableData([]);
				setTotalRecords(0);
			}
		} catch (error) {
			console.error('Error fetching table data:', error);
			toast.error('Failed to fetch table data');
			setAllTableData([]);
			setTotalRecords(0);
		} finally {
			setLoading(false);
		}
	}, [manifestId, accessToken, options]);

	// Handle client-side pagination
	useEffect(() => {
		const startIndex = page * rowsPerPage;
		const endIndex = startIndex + rowsPerPage;
		const paginatedData = allTableData.slice(startIndex, endIndex);
		setTableData(paginatedData);
	}, [allTableData, page, rowsPerPage]);

	useEffect(() => {
		setPickingCreated(false);
		setPicklistUrl('');
		if (manifestId && accessToken) {
			fetchData();
			checkPickingStatus();
		}
	}, [manifestId, accessToken, checkPickingStatus]);

	useEffect(() => {
		fetchTableData();
	}, [fetchTableData]);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const printParam = urlParams.get('print');

		if (printParam === 'true' && !printProcessed && allTableData.length > 0) {
			setPrintProcessed(true);

			const allIds = allTableData.map(row => row.id);
			setSelectedRows(allIds);
			setIsAllSelected(true);

			setTimeout(() => {
				try {
					handleMultiplePrintWithIds(allIds);
					clearPrintUrlParam();
				} catch (error) {
					showPopupBlockedMessage();
					clearPrintUrlParam();
				}
			}, 500);
		}
	}, [allTableData, printProcessed]);

	const handleSequenceBlur = async (invoiceId, sequenceNo) => {
		if (sequenceNo.trim() !== '') {
			try {
				const response = await fetch(`${config.API_URL}/save-sequence-no`, {
					method: 'POST',
					headers: {
						authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ invoice_id: invoiceId, sequence_no: sequenceNo }),
				});

				if (!response.ok) {
					throw new Error('Failed to save sequence number');
				}
			} catch (error) {
				toast.error('Failed to save sequence number.');
			}
		}
	};

	const handleDeleteOrder = async (orderId) => {
		if (window.confirm('Are you sure? Do you want to Remove this order from here?')) {
			try {
				const response = await fetch(`${config.API_URL}/manifest_delete_order`, {
					method: 'POST',
					headers: {
						authorization: `Bearer ${accessToken}`,
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ order_id: orderId, manifest_id: manifestId }),
				});

				if (!response.ok) {
					throw new Error('Failed to delete order');
				}

				toast.success('Order has been deleted.');
				setSelectedRows(prev => prev.filter(id => id !== orderId));
				fetchTableData();
			} catch (error) {
				toast.error('Failed to delete order.');
			}
		}
	};

	const handleCheckboxChange = (rowId, checked) => {
		if (checked) {
			setSelectedRows(prev => [...prev, rowId]);
		} else {
			setSelectedRows(prev => prev.filter(id => id !== rowId));
		}
	};



	const handleClick = async () => {
		let selmainval = `${manifestOrder}`;
		if (!selmainval) {
			toast.error('Please Select order.');
		} else {
			const formOrder = new FormData();
			formOrder.append('update_id', manifestId);
			formOrder.append('order_id', selmainval);
			try {
				const res = await fetch(`${config.API_URL}/manifest_add_order`, {
					method: 'POST',
					headers: {
						authorization: `Bearer ${accessToken}`,
					},
					body: formOrder,
				});
				if (!res.ok) {
					throw new Error('Network response was not ok');
				}
				const data = await res.json();
				fetchData();
				fetchTableData();
				toast.success('Order added successfully!');
			} catch (err) {
				toast.error('Failed to add order.');
			}
		}
	};

	const changeDriver = async (driverId) => {
		const nextDriverId = `${driverId ?? driver}`;
		if (!nextDriverId) {
			return;
		}
		if (!accessToken) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		const formData = new URLSearchParams();
		formData.append('driverid', nextDriverId);
		formData.append('manifestId', manifestId);

		try {
			const response = await fetch(`${config.API_URL}/ws_update_driver`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: formData.toString(),
			});

			if (!response.ok) {
				throw new Error('Failed to submit selection');
			}

			await response.json();
			toast.success('Driver Update successfully');
		} catch (error) {
			toast.error('Failed to update driver.');
		}
	};

	const handlePrintTable = () => {
		// Create a printable version of the table
		const printColumns = [{ header: "Sr. No", key: "sequence_no" }, ...middleColumns];
		const tableHtml = `
			<table style="width: 100%; border-collapse: collapse;">
				<thead>
					<tr style="background-color: #f5f7fa;">
						${printColumns.map(c => `<th style="padding: 8px; border: 1px solid #ddd;">${c.header}</th>`).join('')}
					</tr>
				</thead>
				<tbody>
					${allTableData.map((row, rowIdx) => `
						<tr>
							${printColumns.map(c => {
								const value = c.key === 'sequence_no' && !(Number(row.sequence_no) > 0)
									? rowIdx + 1
									: formatCellValue(row[c.key]);
								return `<td style="padding: 8px; border: 1px solid #ddd;">${value}</td>`;
							}).join('')}
						</tr>
					`).join('')}
				</tbody>
			</table>
		`;

		try {
			const printWindow = window.open('', '', 'width=900,height=700');

			if (!printWindow) {
				showPopupBlockedMessage();
				return;
			}

			setTimeout(() => {
				if (printWindow.closed || printWindow.outerHeight === 0) {
					showPopupBlockedMessage();
					return;
				}

				printWindow.document.write(`
					<html>
						<head>
							<title>Print Table</title>
							<style>
								body { font-family: Arial, sans-serif; padding: 20px; }
								table { width: 100%; border-collapse: collapse; }
								table, th, td { border: 1px solid black; }
								th, td { padding: 8px; text-align: left; }
								thead { background-color: #f1f1f1; }
								.header { margin-bottom: 10px; }
								.header-row { display: flex; gap: 20px; flex-wrap: wrap; }
								.header-item { font-size: 14px; }
							</style>
						</head>
						<body>
							<h2>Route Map</h2>
							<div class="header">
								<div class="header-row">
									<div class="header-item">Manifest No:<strong> ${manifestNo || '-'} </strong> | </div>
									<div class="header-item">Manifest Date:<strong> ${manifestDate || '-'} </strong> | </div>
									<div class="header-item">Driver Name:<strong> ${selectedDriverName || '-'} </strong></div>
								</div>
							</div>
							${tableHtml}
						</body>
					</html>
				`);
				printWindow.document.close();
				printWindow.focus();
				printWindow.print();
				printWindow.close();
			}, 100);
		} catch (error) {
			showPopupBlockedMessage();
		}
	};

	const handleMultiplePrint = () => {
		if (selectedRows.length === 0) {
			toast.warning('Please select at least one order to print.');
			return;
		}

		try {
			sessionStorage.setItem('invoiceIds', JSON.stringify(selectedRows));
			generateMultipleSummaryPDF(howManyInvoiceCanPrint);
		} catch (error) {
			showPopupBlockedMessage();
		}
	};

	const handleMultiplePrintWithIds = (ids) => {
		if (!ids || ids.length === 0) {
			toast.warning('Please select at least one order to print.');
			return;
		}

		sessionStorage.setItem('invoiceIds', JSON.stringify(ids));
		generateMultipleSummaryPDF(howManyInvoiceCanPrint);
	};

	const handleCancelManifest = async () => {
		try {
			const response = await fetch(`${config.API_URL}/manifest_cancel`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ manifest_id: manifestId }),
			});
			if (!response.ok) throw new Error('Cancel failed');
			await response.json();
			toast.success('Route Plan has been cancelled.');
			navigate('/delivery/route_planing');
		} catch (err) {
			toast.error('Failed to cancel manifest.');
		}
	};

	const handleCreateManifest = async () => {
		if (!driver || driver.trim() === '') {
			toast.error('Please Select Driver.');
			return;
		}

		try {
			const formOrder = new FormData();
			formOrder.append('manifest_id', manifestId);
			formOrder.append('driver_id', driver);
			const response = await fetch(`${config.API_URL}/ws-create-manifest-v3`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formOrder,
			});
			const result = await response.json().catch(() => null);

			if (!response.ok || !result || result.success === false || result.status === 'false') {
				const message =
					(result && (result.message || result.error)) || 'Failed to create manifest.';
				toast.error(message);
				return;
			}

			toast.success(result.message || 'Manifest created successfully!');
			navigate('/manifest_list');
		} catch (err) {
			toast.error('Failed to create manifest.');
		}
	};

	const handleConfirmOrders = async () => {
		if (selectedRows.length === 0) {
			toast.error('Please select at least one order.');
			return;
		}

		try {
			const response = await fetch(`${config.API_URL}/confirm-orders`, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ order_ids: selectedRows }),
			});

			if (!response.ok) throw new Error('API error');
			await response.json();

			toast.success('Orders confirmed!');
			setIsAllSelected(false);
			setSelectedRows([]);
			fetchData();
			fetchTableData();
		} catch (err) {
			toast.error('Failed to confirm orders.');
		}
	};

	const handleCreatePicking = () => {
		if (selectedRows.length === 0) {
			toast.error('Please select at least one order to create picking.');
			return;
		}

		setShowPickerModal(true);
	};

	const confirmCreatePicking = async () => {
		if (!selectedPicker) {
			toast.error('Please select a picker.');
			return;
		}

		try {
			const settings = await getCompanySettings();
			const useEncrypt = resolveCustomerApiEncrypt(settings);
			const headers = { authorization: `Bearer ${accessToken}` };
			let body;
			if (useEncrypt) {
				const plain = {
					picker: String(selectedPicker),
					val: selectedRows.map(String),
				};
				const ep = encryptPayload(plain);
				if (!ep) {
					toast.error('Failed to create picking.');
					return;
				}
				const fd = new FormData();
				fd.append("encrypted_payload", ep);
				body = fd;
			} else {
				const formData = new FormData();
				selectedRows.forEach((id) => {
					formData.append('val[]', id);
				});
				formData.append('picker', selectedPicker);
				body = formData;
			}

			const response = await fetch(`${config.API_URL}/create_picking`, {
				method: 'POST',
				headers,
				body,
			});

			if (!response.ok) {
				throw new Error('Failed to create picking');
			}

			const json = await response.json();
			const result = normalizeEncryptedApiResponse(json, useEncrypt) ?? json;

			if (result.status === 'true') {
				let url = '';
				if (result.picklist_number && result.picklist_number !== '0') {
					url = result.picklist_number;
					if (url.includes('/api/admin')) {
						url = url.replace('/api/admin', '');
					} else if (url.includes('/api/')) {
						url = url.replace('/api', '');
					}
					setPicklistUrl(url);
					setPickingCreated(true);
				}
				setShowPickerModal(false);
				setSelectedPicker('');
				setSelectedPickerName('');
				toast.success(result.message || 'Picking successfully created');
				if (url) {
					window.open(url, '_blank');
				}
				checkPickingStatus();
				fetchTableData();
			} else {
				toast.error(result.message || 'Failed to create picking');
			}
		} catch (err) {
			toast.error('Failed to create picking.');
		}
	};

	const handleViewPicking = () => {
		if (picklistUrl) {
			window.open(picklistUrl, '_blank');
		}
	};

	const handleSelectAll = (e) => {
		const checked = e.target.checked;
		setIsAllSelected(checked);

		if (checked) {
			const allIds = tableData.map(row => row.id);
			setSelectedRows(allIds);
		} else {
			setSelectedRows([]);
		}
	};

	useEffect(() => {
		if (tableData.length > 0) {
			const allSelected = tableData.every(row => selectedRows.includes(row.id));
			setIsAllSelected(allSelected);
		} else {
			setIsAllSelected(false);
		}
	}, [tableData, selectedRows]);

	const [showAddOrderModal, setShowAddOrderModal] = useState(false);

	return (
		<>
			<Box className="page-container">
				<Paper
					elevation={0}
					className="paper-style"
				>
					{Object.values(columnVisibility).every(visible => !visible) && (
						<FallbackManageColumns
							onOpenModal={() => setShowFallbackModal(true)}
						/>
					)}
					<Box sx={{ px:2, py:1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
						<FormControl className="input-border" size="small" sx={{ minWidth: 220 }}>
							<InputLabel id="driver-select-label">Select a driver</InputLabel>
							<Select
								labelId="driver-select-label"
								value={driver}
								label="Select a driver"
								onChange={(e) => {
									const selectedOption = options.find(opt => opt.value === e.target.value);
									setSelectedDriver(e.target.value);
									setSelectedDriverName(selectedOption ? selectedOption.key : '');
									changeDriver(e.target.value);
								}}
							>
								<MenuItem value="">Select a driver</MenuItem>
								{options.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.key}
									</MenuItem>
								))}
							</Select>
						</FormControl>
						<Stack direction="row" spacing={1} flexWrap="wrap">
							<Button
								variant="contained"
					
								onClick={() => setShowAddOrderModal(true)}
								className="button-variant-contained"
							>
								Add Order
							</Button>
							<Button
								variant="contained"
								onClick={handlePrintTable}
								className="button-variant-contained"
							>
								Print Manifest
							</Button>
							{pickingCreated ? (
								<Button
									variant="contained"
									onClick={handleViewPicking}
									className="button-variant-contained"
								>
									View Picking
								</Button>
							) : (
								<Button
									variant="contained"
									onClick={handleCreatePicking}
									className="button-variant-contained"
								>
									Create Picking
								</Button>
							)}
						</Stack>
					</Box>
					<TableContainer
					>
						<Table
							size="medium"
							className="table-cell-border"
							sx={{tableLayout: 'fixed'}}
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell
										padding="checkbox">
										<Box>
											<Checkbox
												indeterminate={selectedRows.length > 0 && !isAllSelected}
												checked={isAllSelected}
												onChange={handleSelectAll}
												size="small"
												className="checkBox"
											/>
											{colWidths.length > 0 && (
												<>
													<div
														className="th-resizer"
														onMouseDown={(e) => startResizing(0, e)}
														style={{
															position: 'absolute',
															right: 0,
															top: 0,
															width: '5px',
															height: '100%',
															cursor: 'col-resize',
															zIndex: 1,
														}}
													/>
													<ManageColumns
														tableName={tableName}
														header="Checkbox"
														index={0}
														columns={tableColumns}
														columnVisibility={columnVisibility}
														onColumnVisibilityChange={handleColumnVisibilityChange}
														excludeColumns={["Checkbox", "Sr. No", "Action"]}
													/>
												</>
											)}
										</Box>
									</TableCell>

									{[
										"Sr. No",
										...middleColumns.map((c) => c.header),
										"Action",
									].map((header, idx) => (
										<TableCell
											key={header}
											sx={{width: colWidths[idx + 1], minWidth: 50, position: "relative", display: columnVisibility[idx + 1] !== false ? 'table-cell' : 'none'}}
										>
											<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
												{header}
												<>
													<div
														className="th-resizer"
														onMouseDown={(e) => startResizing(idx + 1, e)}
														style={{
															position: 'absolute',
															right: 0,
															top: 0,
															width: '5px',
															height: '100%',
															cursor: 'col-resize',
															zIndex: 1,
														}}
													/>
													<ManageColumns
														tableName={tableName}
														header={header}
														index={idx + 1}
														columns={tableColumns}
														columnVisibility={columnVisibility}
														onColumnVisibilityChange={handleColumnVisibilityChange}
														excludeColumns={["Checkbox", "Sr. No", "Action"]}
													/>
												</>
											</Box>
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{loading ? (
									<TableRow>
										<TableCell colSpan={middleColumns.length + 3} align="center" sx={{ py: 6 }}>
											<CircularProgress size={24} />
										</TableCell>
									</TableRow>
								) : tableData.length === 0 ? (
									<TableRow>
										<TableCell colSpan={middleColumns.length + 3} align="center" sx={{ py: 6 }}>
											<Typography variant="body2" sx={{ color: '#637381', fontSize: '0.75rem' }}>
												No records found.
											</Typography>
										</TableCell>
									</TableRow>
								) : (
									tableData.map((row, index) => (
										<TableRow
											key={row.id || index}
											hover
											className="table-cell-style"
										>
											<TableCell
												padding="checkbox"
											>
												<Checkbox
													size="small"
													checked={selectedRows.includes(row.id)}
													onChange={(e) => handleCheckboxChange(row.id, e.target.checked)}
													className="checkBox"
												/>
											</TableCell>
											<TableCell
												sx={{
													textAlign: 'center',
													borderBottom: '1px dashed rgba(145, 158, 171, 0.16)', display: columnVisibility[1] !== false ? 'table-cell' : 'none'
												}}
											>
												<TextField
													size="small"
													value={
														row.sequence_no !== null && row.sequence_no !== undefined && Number(row.sequence_no) > 0
															? row.sequence_no
															: String(page * rowsPerPage + index + 1)
													}
													onChange={(e) => {
														const updatedAllData = [...allTableData];
														const dataIndex = updatedAllData.findIndex(r => r.id === row.id);
														if (dataIndex !== -1) {
															updatedAllData[dataIndex].sequence_no = e.target.value;
															setAllTableData(updatedAllData);
														}
													}}
													onBlur={(e) => handleSequenceBlur(row.id, e.target.value)}
													placeholder="Enter Seq"
													sx={{
														width: '100%',
														'& .MuiOutlinedInput-root': {
															fontSize: '0.75rem',
															height: '32px',
															'& fieldset': {
																borderColor: 'rgba(44, 46, 48, 0.83)',
															},
														},
													}}
												/>
											</TableCell>
											{middleColumns.map((col, colIdx) => (
												<TableCell
													key={col.key}
													sx={{
														textAlign: col.align || 'left',
														display: columnVisibility[colIdx + 2] !== false ? 'table-cell' : 'none',
														...(col.type === 'link' && { textDecoration: 'underline' }),
														...(col.key === 'customer' && { whiteSpace: 'normal', wordBreak: 'break-word' }),
														...((col.key === 'date' || col.key === 'invoice_num') && { whiteSpace: 'nowrap' }),
													}}
												>
													{col.type === 'link' ? (
														<Link
															to={`${config.BASE_URL}/trip_summary/print/${row.id}`}
															target="_blank"
															style={{ color: '#212B36', textDecoration: 'underline' }}
														>
															{formatCellValue(row[col.key])}
														</Link>
													) : (
														formatCellValue(row[col.key])
													)}
												</TableCell>
											))}
											<TableCell
												sx={{
													textAlign: 'center',

													display: columnVisibility[middleColumns.length + 2] !== false ? 'table-cell' : 'none'
												}}
											>
												<IconButton
													size="small"
													onClick={() => handleDeleteOrder(row.id)}
													sx={{
														color: '#f14240',
														'&:hover': {
															backgroundColor: 'rgba(241, 66, 64, 0.08)',
														},
													}}
												>
													<Iconify icon="eva:trash-2-outline" width={18} height={18} />
												</IconButton>
											</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
					<TablePagination
						component="div"
						count={totalRecords}
						page={page}
						onPageChange={handleChangePage}
						rowsPerPage={rowsPerPage}
						onRowsPerPageChange={handleChangeRowsPerPage}
						rowsPerPageOptions={[10, 25, 50, 100]}
						labelRowsPerPage="Rows per page:"
						className="pagination-styles"
					/>
					{!isManifest && (
						<Box
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								gap: 2,
								padding: 2,
								borderTop: '1px solid rgba(145, 158, 171, 0.16)',
							}}
						>
							<Button
								variant="outlined"
								onClick={handleCancelManifest}
								className="button-variant-outlined"
							>
								Cancel
							</Button>
							<Button
								variant="contained"
								onClick={handleCreateManifest}
								className="button-variant-contained"
							>
								Create Manifest
							</Button>
						</Box>
					)}
				</Paper>
			</Box>
		
			<StandaloneManageColumnsModal
				show={showFallbackModal}
				onHide={() => setShowFallbackModal(false)}
				tableName={tableName}
				columns={tableColumns}
				columnVisibility={columnVisibility}
				onColumnVisibilityChange={handleColumnVisibilityChange}
				excludeColumns={["Checkbox", "Action", "Sr. No"]}
			/>

			<Dialog
				open={showPickerModal}
				onClose={() => {
					setShowPickerModal(false);
					setSelectedPicker('');
					setSelectedPickerName('');
				}}
				maxWidth="sm"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
						Select Picker
					</Typography>
					<IconButton
						onClick={() => {
							setShowPickerModal(false);
							setSelectedPicker('');
							setSelectedPickerName('');
						}}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<FormControl fullWidth sx={{ mt: 1 }}>
						<InputLabel id="picker-select-label">Choose Picker</InputLabel>
						<Select
							labelId="picker-select-label"
							value={selectedPicker}
							label="Choose Picker"
							onChange={(e) => {
								const selectedOption = pickerOptions.find(opt => opt.value === e.target.value);
								setSelectedPicker(e.target.value);
								setSelectedPickerName(selectedOption ? selectedOption.key : '');
							}}
							sx={{
								borderRadius: '8px',
								'& .MuiOutlinedInput-root': {
									backgroundColor: '#F4F6F8',
									'& fieldset': {
										borderColor: 'rgba(145, 158, 171, 0.32)',
									},
								},
							}}
						>
							<MenuItem value="">Select a picker</MenuItem>
							{pickerOptions.map(option => (
								<MenuItem key={option.value} value={option.value}>
									{option.key}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => {
							setShowPickerModal(false);
							setSelectedPicker('');
							setSelectedPickerName('');
						}}
						variant="outlined"
						className="button-variant-outlined"
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={confirmCreatePicking}
						className="button-variant-contained"
					>Create Picking
						
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showAddOrderModal}
				onClose={() => setShowAddOrderModal(false)}
				maxWidth="sm"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Add New Order
					</Typography>
					<IconButton
						onClick={() => setShowAddOrderModal(false)}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<Autocomplete
						options={orderOptions}
						value={orderOptions.find((option) => String(option.value) === String(manifestOrder)) || null}
						onChange={(_, newValue) => {
							setmanifestOrder(newValue ? newValue.value : "");
						}}
						getOptionLabel={(option) => option?.label || option?.key || ""}
						isOptionEqualToValue={(option, value) =>
							String(option?.value) === String(value?.value)
						}
						filterOptions={(options, state) => {
							const query = String(state.inputValue || "").trim().toLowerCase();
							if (!query) return options;
							return options.filter((option) => {
								const key = String(option.key || "").toLowerCase();
								const customer = String(option.customer || "").toLowerCase();
								const label = String(option.label || "").toLowerCase();
								return (
									key.includes(query) ||
									customer.includes(query) ||
									label.includes(query)
								);
							});
						}}
						renderOption={(props, option) => (
							<li {...props} key={option.value}>
								<Box sx={{ display: "flex", flexDirection: "column", py: 0.25 }}>
									<Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
										{option.key}
									</Typography>
									{option.customer ? (
										<Typography variant="caption" sx={{ color: "#212b36", lineHeight: 1.3 }}>
											{option.customer}
										</Typography>
									) : null}
								</Box>
							</li>
						)}
						renderInput={(params) => (
							<TextField
								{...params}
								className="input-border"
								label="Select Order"
								placeholder="Search order or customer..."
								size="small"
							/>
						)}
						sx={{ mt: 1 }}
						ListboxProps={{
							style: { maxHeight: 320 },
						}}
					/>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => setShowAddOrderModal(false)}
						className="button-variant-outlined"
						variant="outlined"
					>
						Close
					</Button>
					<Button
						variant="contained"
						className="button-variant-contained"
						onClick={() => {
							handleClick();
							setShowAddOrderModal(false);
						}}
					
					>
						Add Order
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default NewMarkDelivery;
